/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountRoleName } from './accountRoleName';
import { AccountRolePermissions } from './accountRolePermissions';


export interface AccountRole { 
    name?: AccountRoleName;
    permissions?: AccountRolePermissions;
}
export namespace AccountRole {
}


